console.log('top');

// ______________________________________
// 動画読み込み関連
// mv部分
function setupMainVideo() {
    const isSp = window.matchMedia("(max-width: 767px)").matches;
    const pcVideo = document.querySelector(".mainVideo._pc");
    const spVideo = document.querySelector(".mainVideo._sp");

    if (!pcVideo || !spVideo) return;

    if (isSp) {
        spVideo.src = "assets/img/top/TOP_SP.mp4";
        spVideo.load();
        pcVideo.removeAttribute("src");
        pcVideo.load();
    } else {
        pcVideo.src = "assets/img/top/TOP_PC.mp4";
        pcVideo.load();
        spVideo.removeAttribute("src");
        spVideo.load();
    }
}
// コンセプト部分
// function setupConceptVideo() {
//     const isSp = window.matchMedia("(max-width: 767px)").matches;
//     const pcVideo = document.querySelector(".conceptVideo._pc");
//     const spVideo = document.querySelector(".conceptVideo._sp");

//     if (!pcVideo || !spVideo) return;

//     const activeVideo = isSp ? spVideo : pcVideo;
//     const inactiveVideo = isSp ? pcVideo : spVideo;

//     inactiveVideo.pause();
//     inactiveVideo.removeAttribute("src");
//     inactiveVideo.load();

//     const io = new IntersectionObserver((entries, observer) => {
//         entries.forEach((entry) => {
//             if (!entry.isIntersecting) return;

//             if (!activeVideo.getAttribute("src")) {
//                 activeVideo.src = activeVideo.dataset.src;
//                 activeVideo.load();
//             }

//             activeVideo.play().catch(() => { });
//             observer.disconnect();
//         });
//     }, { rootMargin: "300px 0px" });

//     io.observe(activeVideo);
// }
// ______________________________________
// top動画

const skipBtn = document.getElementById('skipBtn');
const replayBtn = document.getElementById('replayBtn');

function fadeOut(el) {
    el.classList.add('fade-hidden');
}
function fadeIn(el) {
    el.classList.remove('fade-hidden');
}

// SP/PC 判定して対象を取得
function getCurrentElements() {
    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const video = document.querySelector(`.mainVideo.${isSp ? '_sp' : '_pc'}`);
    const img = document.querySelector(`.skipImage.${isSp ? '_sp' : '_pc'}`);
    const note = document.querySelector('.com-imgnote');
    return { video, img, note };
}

// 「動画→画像」＋「ボタンをSKIP→REPLAY」
function showSkipImage() {
    const { video, img, note } = getCurrentElements();
    if (!video || !img) return;

    fadeOut(video);
    fadeIn(img);
    if (note) fadeIn(note);

    skipBtn.style.display = 'none';
    replayBtn.style.display = 'inline-block';
}

// 「画像→動画」＋「ボタンをREPLAY→SKIP」
function replayVideo() {
    const { video, img, note } = getCurrentElements();
    if (!video || !img) return;

    fadeOut(img);
    fadeIn(video);
    if (note) fadeOut(note);

    video.pause();
    video.currentTime = 0;
    video.play();

    skipBtn.style.display = 'inline-block';
    replayBtn.style.display = 'none';
}

// 初期化
window.addEventListener('DOMContentLoaded', () => {
    // 画像、キャプションは最初は非表示
    document.querySelectorAll('.skipImage').forEach(img => img.classList.add('fade-hidden'));
    const note = document.querySelector('.com-imgnote');
    if (note) note.classList.add('fade-hidden');
    // REPLAYボタン非表示（CSSでもOKだけど念のため）
    replayBtn.style.display = 'none';

    // ボタンイベント
    skipBtn.addEventListener('click', showSkipImage);
    replayBtn.addEventListener('click', replayVideo);

    // 動画が最後まで行ったら自動で showSkipImage()
    document.querySelectorAll('.mainVideo').forEach(video => {
        video.addEventListener('ended', showSkipImage);
    });
});

// （既存の fade-text 処理が必要ならそのまま）
document.querySelectorAll('.fade-text').forEach(el => {
    const text = el.textContent;
    el.innerHTML = [...text].map(char => `<span>${char}</span>`).join('');
});

// ______________________________________
// 下固定エントリーボタン
// let lastScrollTop = 0;
// let scrollUpDistance = 0;
// let scrollDownDistance = 0;

// const btn = document.querySelector('.bottom_btn');

// window.addEventListener('scroll', () => {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     const threshold = window.innerHeight * 0.3; // 10vh

//     if (scrollTop < lastScrollTop) {
//         // 上スクロール
//         scrollUpDistance += lastScrollTop - scrollTop;
//         scrollDownDistance = 0;

//         if (scrollUpDistance > threshold) {
//             btn.classList.add('is-show');
//         }
//     } else if (scrollTop > lastScrollTop) {
//         // 下スクロール
//         scrollDownDistance += scrollTop - lastScrollTop;
//         scrollUpDistance = 0;

//         if (scrollDownDistance > threshold) {
//             btn.classList.remove('is-show');
//         }
//     }

//     lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
// });

// ______________________________________
// mv下固定フェードスクロール

document.addEventListener('DOMContentLoaded', function () {
    const section = document.getElementById('fadeContent');
    const text1 = section.querySelector('.center_text');
    const text2 = section.querySelector('.center_text2');

    function lerp(a, b, t) {
        return a + (b - a) * t;
    }

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function updateFadeText() {
        const rect = section.getBoundingClientRect();
        const viewportH = window.innerHeight;
        const scrollable = rect.height - viewportH;
        const progress = clamp(-rect.top / scrollable, 0, 1);

        const isSp = window.matchMedia('(max-width: 768px)').matches;

        // text1 → text2 の切り替え
        const t1Start = 0.30;
        const t1End = 0.48;

        // text2 の表示維持
        const t2StayStart = 0.48;
        const t2StayEnd = isSp ? 0.90 : 0.90;

        // text2 のフェードアウト
        const t2FadeOutStart = isSp ? 0.95 : 0.95;
        const t2FadeOutEnd = isSp ? 0.99 : 0.99;

        let opacity1 = 0;
        let blur1 = 100;
        let opacity2 = 0;
        let blur2 = 100;

        // text1
        if (progress <= t1Start) {
            opacity1 = 1;
            blur1 = 0;
        } else if (progress < t1End) {
            const t = (progress - t1Start) / (t1End - t1Start);
            opacity1 = lerp(1, 0, t);
            blur1 = lerp(0, 16, t);
        } else {
            opacity1 = 0;
            blur1 = 16;
        }

        // text2
        if (progress < t1Start) {
            opacity2 = 0;
            blur2 = 16;
        } else if (progress < t1End) {
            const t = (progress - t1Start) / (t1End - t1Start);
            opacity2 = lerp(0, 1, t);
            blur2 = lerp(16, 0, t);
        } else if (progress < t2StayEnd) {
            opacity2 = 1;
            blur2 = 0;
        } else if (progress < t2FadeOutEnd) {
            const t = (progress - t2FadeOutStart) / (t2FadeOutEnd - t2FadeOutStart);
            opacity2 = lerp(1, 0, t);
            blur2 = lerp(0, 16, t);
        } else {
            opacity2 = 0;
            blur2 = 16;
        }

        text1.style.opacity = opacity1;
        text1.style.filter = `blur(${blur1}px)`;

        text2.style.opacity = opacity2;
        text2.style.filter = `blur(${blur2}px)`;
    }

    updateFadeText();
    window.addEventListener('scroll', updateFadeText, { passive: true });
    window.addEventListener('resize', updateFadeText);
});

// ______________________________________
// 動画拡大アニメーション

// function setupZoomAnimation() {
//     const section = document.querySelector(".zoomup_movie");
//     const movie = document.querySelector(".movie_theAnswer");

//     if (!section || !movie) return;

//     let mm = gsap.matchMedia();

//     mm.add(
//         {
//             isSP: "(max-width: 767px)",
//             isPC: "(min-width: 768px)"
//         },
//         (context) => {
//             const { isSP } = context.conditions;
//             const startWidth = isSP ? "60%" : "20%";

//             gsap.set(movie, { width: startWidth });

//             const zoomTween = gsap.fromTo(
//                 movie,
//                 { width: startWidth },
//                 {
//                     width: "100%",
//                     ease: "none",
//                     scrollTrigger: {
//                         trigger: ".zoomup_movie",
//                         start: "top top",
//                         end: "bottom-=10% bottom",
//                         scrub: true
//                     }
//                 }
//             );

//             const switchTrigger = ScrollTrigger.create({
//                 trigger: ".zoomup_movie",
//                 start: "bottom-=20% bottom",
//                 end: "bottom bottom",
//                 onEnter: () => section.classList.add("is-switched"),
//                 onLeaveBack: () => section.classList.remove("is-switched")
//             });

//             return () => {
//                 zoomTween.kill();
//                 switchTrigger.kill();
//                 section.classList.remove("is-switched");
//             };
//         }
//     );
// }

window.addEventListener("DOMContentLoaded", () => {
    setupMainVideo();
});

// ______________________________________
// 

// ______________________________________
// 
